import { ServicePointModel } from "@/views/loyalty/models/service_point.model"

export class ServicePointService {
    constructor (data) {
        this.pointId = data ? data.id : ""
        this.number = data ? data.number : 0
        this.name = data ? data.name : ""
        this.place = data ? data.place : ""
        // this.placeHuman = ""
        this.client = data ? data.client : ""
        // this.clientHuman = ""
        this.availability = false
        this.point_clients = []
        this.point_places = []
        this.obj = {}
    }

    add_point_clients (data) {
        // this.clientHuman = data.filter(f => f.id === this.client).map(m => m.legal.name.short).join()
        // console.log('this.clientHuman', this.clientHuman)
        this.point_clients = data
        return this
    }

    add_point_data (data) {
        this.pointId = data ? data.id : ""
        this.number = data ? data.number : 0
        this.name = data ? data.name : ""
        this.place = data ? data.place : ""
        this.client = data ? data.client : ""
        this.availability = false
        this.obj = Object.assign({}, {
            pointId: this.pointId,
            number: this.number,
            name: this.name,
            availability: this.availability
        })
        return this
    }

    add_point_places (data) {
        // this.placeHuman = data.filter(f => f.id === this.place).map(m => m.name + " | " + m.address).join()
        this.point_places = data
        return this
    }

    get placeHuman () {
        return this.point_places.filter(f => f.id === this.place).map(m => this.name + " | " + m.address).join()
    }

    get clientHuman () {
        return this.point_clients.filter(f => f.id === this.client).map(m => m.legal.name.short).join()
    }

    get item () {
        Object.assign(this.obj, { placeHuman: this.placeHuman, clientHuman: this.clientHuman })
        return this.obj
    }
}
